import { ErrorCodes } from 'enums';

export class NotFoundError extends Error {
  code: ErrorCodes = ErrorCodes.NOT_FOUND;

  constructor() {
    super('Recurso não encontrado.');
    this.name = 'NotFoundError';

    return this;
  }
}
